var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"proposal-img",attrs:{"rounded":"md","href":_vm.link,"elevation":"2"},on:{"click":function($event){$event.preventDefault();return _vm.handleLink.apply(null, arguments)}}},[_c('v-img',{attrs:{"src":_vm.src,"alt":_vm.proposal.name,"contain":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }